import React from "react";
import { Helmet } from "react-helmet";

const TransactionSEO = () => {
  return (
     <Helmet>
        {/* Page title optimized for the transaction page */}
        <title>Betpro Wallet Transactions - Track Your Payments</title>
        <link rel="icon" href="https://betprowallet.net/favicon.ico" />

        {/* Canonical tag */}
        <link rel="canonical" href="https://betprowallet.net/transactions" />

        {/* Meta description focusing on viewing and managing transactions */}
        <meta name="description" content="Track and manage your transactions with Betpro Wallet. 🏦 View your deposit and withdrawal history easily on Betprowallet.net for a transparent and secure betting experience." />

        {/* Meta keywords for search engine optimization */}
        <meta name="keywords" content="Betpro Wallet transactions, track payments, transaction history, manage deposits and withdrawals, Betprowallet.net transactions" />

        {/* Meta author */}
        <meta name="author" content="Betpro Wallet" />

        {/* Open Graph meta tags for social media sharing */}
        <meta property="og:title" content="Betpro Wallet Transactions - Track Your Payments" />
        <meta property="og:description" content="Easily track and manage your transaction history with Betpro Wallet. View deposits, withdrawals, and stay updated on your account activity with Betprowallet.net." />
        <meta property="og:url" content="https://betprowallet.net/transactions" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://betprowallet.net/bpthumb2.jpg" />

        {/* Twitter Card for sharing on Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Betpro Wallet Transactions - Track Your Payments" />
        <meta name="twitter:description" content="Monitor and manage your transaction history easily on Betprowallet.net. Transparent records for all deposits and withdrawals with Betpro Wallet." />
        <meta name="twitter:image" content="https://betprowallet.net/bpthumb2.jpg" />

        {/* Structured Data for SEO */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Betpro Wallet Transactions - Track Your Payments",
        "url": "https://betprowallet.net/transactions",
        "description": "Easily track and manage your Betpro Wallet transaction history. Stay updated on deposits, withdrawals, and all account activities.",
        "publisher": {
          "@type": "Organization",
          "name": "Betpro Wallet"
        }
      }
    `}
        </script>


      </Helmet>
);
};

export default TransactionSEO;
